import React, { useState, useEffect } from "react";
import { useNavigate,useLocation  } from "react-router-dom";
import Button from "../../../components/atoms/Button";
import styles from "./index.module.css";
import ArrowRight from "../../../images/icons/arrow_right.svg";
import BackArrow from "../../../images/icons/arrow-left-circle.svg";
import bigcalendar from "../../../images/icons/bigcalendar.svg";
import bigemi from "../../../images/icons/bigemi.svg";
import emi from "../../../images/icons/emi.png"
import download from "../../../images/icons/download.svg";
import biginterest from "../../../images/icons/biginterest.svg";
import {jwtDecode} from "jwt-decode";
import axios from "axios";
import { newFormatToIndianRupees } from "../../../utils/formatToIndianRpuees";
import { getNextFifthDate } from "../../../utils/getNextFifthDate";
import selected from "../../../images/icons/selected.png"
import { ApplicantStage } from "../../../utils/applicationStage";
import Navbar from "../../../components/molecules/Navbar";
import  Checkbox  from "@mui/material/Checkbox";
import { FormControlLabel, Radio } from "@mui/material";
import Footer from "../../../components/molecules/Footer";
import axiosInstance from "../../../../helpers/axios";
// Define the structure of summary data
interface SummaryData {
  mobile: string;
  userId: string;
  applicationId: string;
  courseFees:any
  instituteId?: string;
}

function ViewOffer() {
  const navigate = useNavigate();
  const [selectedDate, setSelectedDate] = useState("");
  const [summaryData, setSummaryData] = useState<SummaryData | null>(null);
  const [loading, setLoading] = useState(false)
  const location = useLocation();
  const stateData = location?.state?.data;
  console.log(stateData, 'view details page')
  const [products, setProducts] = useState([
    {
      tenure: 0,
    },
  ]);
  const [activeEmiPlan, setActiveEmiPlan] = useState("");
  const [emiAmount, setEmiAmount] = useState("");
  const [emiPlans, setEmiPlans] = useState<any[]>([]);
  const [emiApiMessage, setEmiApiMessage] = useState<string>("");


const data = sessionStorage.getItem("data")
    let [userData, setUserData] = useState<{
      application:string,
      dob:string,
      applicationId: string;
      userId: string;
      email: string;
      panId: string;
      dateOfBirth: string;
      instituteId: string;
      firstName: string;
      lastName: string;
      mobile: string;
      course: string;
      courseFees: number;
      studentName: string;
      instituteName: string;
      redirectUrl: string;
      channelId: number;
      flow:string;
    }>({
      application:'',
      applicationId: "",
      userId: "",
      instituteId: "",
      firstName: "",
      lastName: "",
      panId: "",
      dateOfBirth: "",
      dob:'',
      email: "",
      mobile: "",
      course: "",
      courseFees: 0,
      studentName: "",
      instituteName: "",
      redirectUrl: "",
      channelId: 0,
      flow:''
    });
    useEffect(() => {
      if (data) {
        try {
          const jsonData = atob(data)
          setUserData(JSON.parse(jsonData));
        } catch (error) {}
      }
  
    }, []);
  const courseFees = userData?.courseFees?userData?.courseFees:stateData?.courseFees 
  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const date = e.target.value;
    setSelectedDate(date);
  };

  const formatDate = (date: string) => {
    const [year, month, day] = date.split("-");
    return `${day}-${month}-${year}`;
  };

  const user = sessionStorage.getItem("auth_token") || "";
  
    let decode: any;
    let token: any
    if (user) {
      try {
        decode = JSON.parse(user).value;
        token = jwtDecode(JSON.parse(user).value) as any;
        console.log("token",token);
      } catch (error) {
        console.error("Error parsing user token:", error);
      }
    } else {
      console.error("Auth token not found");
    }
  // const decode = JSON.parse(user || "").value as any;
  console.log(decode);
  



  useEffect(() => {
    const fetchForChannel12 = async () => {
      try {
        if (userData?.channelId !== 12) {
          // If not channel 12, fallback to taking summary data from location state
          const { mobile, userId, applicationId, courseFees, instituteId } = location?.state?.data || {};
          setSummaryData({ mobile, userId, applicationId, courseFees, instituteId });
          return;
        }

        // derive userId and applicationId preferring location.state values
        const loc = location?.state?.data || {};
        const userIdFromLocation = loc?.userId || loc?.id;
        const applicationIdFromLocation = loc?.applicationId || loc?.application || (loc?.existing ? loc.applicationId : undefined);

        const userId = userIdFromLocation || userData?.userId || (userData as any)?.id;
        const applicationId = applicationIdFromLocation || userData?.applicationId;

        if (!userId || !applicationId) {
          console.error('Missing userId or applicationId for summary fetch');
          return;
        }

        const url = `${process.env.REACT_APP_DASHBOARD_URL}/summary/user?id=${userId}&applicationId=${applicationId}`;
        const headers: any = {};
        if (decode) headers.Authorization = `Bearer ${decode}`;

        const response = await axios.get(url, { headers });
        const { mobile, userId: respUserId, applicationId: respAppId, courseFees, instituteId } = response?.data?.data || {};
        console.log(response?.data?.data, 'view offers summary (channel 12)');
        setSummaryData({ mobile, userId: respUserId || userId, applicationId: respAppId || applicationId, courseFees, instituteId });

        // For channel 12 we do not fetch institute products here; emi-amount is fetched below.
        // For channelId 12: also fetch EMI amount for the application on page load
        try {
          const applicationIdForEmi = applicationId;
          if (userData?.channelId === 12 && applicationIdForEmi) {
            const headers: any = {};
            if (decode) headers.Authorization = `Bearer ${decode}`;
            const res = await axiosInstance.get(
              `${process.env.REACT_APP_DASHBOARD_URL}/admin/application/emi-amount?applicationId=${applicationIdForEmi}`,
              { headers }
            );
            const msg = res?.data?.message;
            if (msg && msg !== "Successful") {
              setEmiApiMessage(msg || "");
              setEmiPlans([]);
              setProducts([]);
            } else {
              const arr = res?.data?.data?.data || [];
              const mapped = arr.map((p: any) => ({
                productId: p.productId,
                tenure: p.tenure,
                emi: p.emi,
              }));
              setEmiPlans(mapped);
              setProducts(mapped);
              setEmiApiMessage("");
              if (mapped.length > 0) {
                setActiveEmiPlan(mapped[0].productId);
                setEmiAmount(String(mapped[0].emi));
              }
            }
          }
        } catch (err) {
          console.error("Error fetching EMI amount for channel 12", err);
        }
      } catch (error) {
        console.error('Error fetching summary data:', error);
      }
    };

    fetchForChannel12();
  }, [location?.state?.data, userData?.channelId, userData?.userId, userData?.applicationId]);

  const approve = async (data: any) => {
    return fetch(`${process.env.REACT_APP_DASHBOARD_URL}/application/approve`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${decode}`,
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        return response.json();
      })
      .catch((error) => {
        return console.error(error);
      });
  };

  const handleButtonClick = async () => {
    setLoading(true)
    const updateStatusUrl = `${process.env.REACT_APP_DASHBOARD_URL}/admin/application/assign-fund-source`;

    let emidate=new Date()
    let current=null
    if (emidate.getMonth() == 11) {
      current = `${emidate.getFullYear() + 1}/01/05`
    } else {
      current = `${emidate.getFullYear()}-${emidate.getMonth() + 2}-05`
    }
    const selectedApiProduct = emiPlans.find((p: any) => p.productId === activeEmiPlan);
    const statusData = {
      applicationId: userData?.applicationId
        ? userData?.applicationId
        : stateData.existing
        ? stateData?.applicationId
        : stateData?.application,
      fundCode: "GBP",
      productId:
        userData?.channelId === 12 && selectedApiProduct
          ? selectedApiProduct.productId
          : activeEmiPlan,
      loanAmount: courseFees,
      emi:
        userData?.channelId === 12 && selectedApiProduct
          ? Number(selectedApiProduct.emi)
          : Number(emiAmount),
      emiFirstDate: current,
      dayOfEmi: 5,
      rulesStatus: 1,
    };

    console.log("statusData", statusData);
     const authTokenResponse = await fetch(
        `${process.env.REACT_APP_DASHBOARD_URL}/login/auth`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            memberId: userData?.channelId === 12?"7b75d903-dabf-4571-9052-61c825403004":location?.state?.data?.userId,
          }),
        }
      );

      const authTokenResult = await authTokenResponse.json();
    axios.post(`${updateStatusUrl}`, statusData, {
              headers: {
                Authorization: `Bearer ${authTokenResult?.data}`,
                'Content-type': 'application/json',
              },
    })
      .then((res) => {
          if (res.data.message === 'Successful') {
             navigate("/bankstatement-evaluation", {
                state: { data: location?.state?.data },
              });
          setLoading(false)
          }
        },
      ).catch((e)=>{
         setLoading(false)
        console.log(e, 'assign-found-source-error')
      })

  };

 useEffect(() => {
  const fetchData = async () => {
    try {
      if (userData?.channelId === 12) return;
      console.log("instname--->", userData?.instituteName, location.state.data.instituteName);
      
      const instituteName = userData?.instituteName || location.state.data.instituteName;
      
      if (!instituteName) {
        console.error("No institute name found");
        return;
      }
      
      // First API call
      const response1 = await fetch(`${process.env.REACT_APP_DASHBOARD_URL}/institute/info/name?name=${instituteName}`, {
        method: "GET"
      });

      if (!response1.ok) {
        throw new Error(`HTTP error! status: ${response1.status}`);
      }

      const result1 = await response1.json();
      console.log("result1--->", result1?.data[0]);
      const inst = result1?.data[0]
      
      // Second API call
      const response2 = await fetch(`${process.env.REACT_APP_DASHBOARD_URL}/products/instituteId?instituteId=${inst?.id}`);
      
      if (!response2.ok) {
        throw new Error(`HTTP error! status: ${response2.status}`);
      }
      
      const data = await response2.json();
      console.log("data--->",data)
      setProducts(data.data);
      
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  fetchData();
}, [userData?.instituteName]);

useEffect(() => {
  const fetchApplicationStage = async () => {
    try {
      // Get applicationId with proper fallback
      const applicationId = userData?.applicationId || 
        (stateData?.existing ? stateData.applicationId : stateData?.application);
      
      // Validate applicationId before making the API call
      if (!applicationId) {
        console.error('No valid applicationId found');
        return;
      }

      console.log('Fetching stage with applicationId:', applicationId);

      const response = await fetch(
        `${process.env.REACT_APP_DASHBOARD_URL}/admin/application/stage?applicationId=${applicationId}`
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const res = await response.json();
      
      if (res?.data?.stage) {
        switch (res?.data?.stage) {
          case ApplicantStage.PanVerification:
            navigate(`/pan-details/${atob(JSON.stringify(location?.state?.data))}`);
            break;
          case ApplicantStage.EmploymentDetails:
            navigate("/identify-yourself", {
              state: { data: location?.state?.data, stage: res.data.skipStatement },
            });
            break;
          case ApplicantStage.AddressDetails:
            navigate("/work-details", {
              state: { data: location?.state?.data, stage: res.data.skipStatement },
            });
            break;
          case ApplicantStage.BankStatement:
            navigate("/view-offers", {
              state: { data: location?.state?.data },
            });
            break;
          case ApplicantStage.AwaitingApproval:
            navigate("/parking-page", {
              state: { data: location?.state?.data },
            });
            break;
          case ApplicantStage.CoapplicantRequired:
            navigate("/parking-page", {
              state: { data: location?.state?.data },
            });
            break;
          case ApplicantStage.AwaitingCoapplicantConsent:
            navigate("/parking-page", {
              state: { data: location?.state?.data },
            });
            break;
          case ApplicantStage.Approved:
            navigate("/select-emi", {
              state: { data: location?.state?.data },
            });
            break;
          case ApplicantStage.SanctionTermsAccepted:
            navigate("/sanctions", {
              state: { data: location?.state?.data },
            });
            break;
          case ApplicantStage.Digilocker:
            navigate("/sanctions", {
              state: { data: location?.state?.data },
            });
            break;
          case ApplicantStage.Selfie:
            navigate("/sanctions", {
              state: { data: location?.state?.data },
            });
            break;
          case ApplicantStage.Agreement:
            navigate("/sanctions", {
              state: { data: location?.state?.data },
            });
            break;
          case ApplicantStage.BankAccountVerified:
            navigate("/sanctions", {
              state: { data: location?.state?.data },
            });
            break;
          case ApplicantStage.Mandate:
            navigate("/pf-collection", {
              state: { data: location?.state?.data },
            });
            break;
          case ApplicantStage.PFCollections:
            navigate("/pf-collection", {
              state: { data: location?.state?.data },
            });
            break;
          case ApplicantStage.ProcessComplete:
            navigate("/disbursed-page", {
              state: { data: location?.state?.data },
            });
            break;
          case ApplicantStage.Disbursed:
            navigate("/disbursed-page", {
              state: { data: location?.state?.data },
            });
            break;
          case ApplicantStage.Rejected:
            navigate("/rejected-page", {
              state: { data: location?.state?.data },
            });
            break;
          default:
            try {
              navigate(`/${atob(JSON.stringify(location?.state?.data))}`);
            } catch (err) {
              navigate(`/pan-details/:data`);
            }
            break;
        }
      }
    } catch (error) {
      console.error('Error fetching application stage:', error);
    }
  };

  fetchApplicationStage();
}, [userData?.applicationId, stateData?.applicationId, stateData?.application]);

  console.log(location?.state?.data, 'view offers location data')
  return (
    <div className={styles.body}>
       <Navbar />
      <div className={styles.container}>
          <div className={styles.main}>
          {/* <div className={styles.Header}>
            <button
              style={{ border: "none", background: "none" }}
              onClick={() => {
                navigate(-1);
              }}
            >
              <img
                style={{ marginLeft: "0.5rem", height: "1.5rem" }}
                src={BackArrow}
                alt=""
              />
            </button>
            <p style={{ marginRight: "0.5rem", fontWeight: "bold" }}>T&C</p>
          </div> */}
          <div
            style={{
              background: "#FFF7F2",
              border: "1px solid #F9D8D6",
              borderRadius: "12px 12px 0px 0px",
            }}
          >
            <p
              style={{
                fontSize: "1.5rem",
                textAlign: "center",
                fontWeight: "bold",
                marginTop:'12px'
              }}
            >
            {newFormatToIndianRupees(courseFees)}
            </p>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              border: "1px solid #F9D8D6",
              background: "#ffffff",
              paddingTop:'12px',
              boxShadow: "0px 3px 3px rgba(211, 32, 40, 0.1)",
              borderRadius: "0px 0px 12px 12px",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "2rem",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  flex: 1,
                }}
              >
                <img
                  src={bigemi}
                  style={{ width: "40px",height:'40px', marginBottom: "0.5rem" }}
                />
                <p style={{ color: "#737373", fontSize: "0.875rem" }}>EMI</p>
                <p style={{ fontSize: "0.875rem", fontWeight: "bold" }}>
                  {userData?.channelId === 12
                    ? activeEmiPlan
                      ? `${newFormatToIndianRupees(Number(emiAmount) || 0)}`
                      : "₹ 0"
                    : activeEmiPlan
                    ? `${newFormatToIndianRupees(
                        Number(
                          Number(
                            courseFees /
                              Number(
                                products
                                  .sort((a, b) => a.tenure - b.tenure)
                                  .find((product: any) =>
                                    product.productId === activeEmiPlan
                                  ) &&
                                  products
                                    .sort((a, b) => a.tenure - b.tenure)
                                    .find(
                                      (product: any) =>
                                        product.productId === activeEmiPlan
                                    )?.tenure
                              )
                          ).toFixed(2)
                        )
                      )}`
                    : "₹ 0"}
                </p>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  flex: 1,
                }}
              >
                <img
                  src={bigcalendar}
                  style={{ width: "40px",height:'40px', marginBottom: "0.5rem" }}
                />
                <p style={{ color: "#737373", fontSize: "0.875rem" }}>TENURE</p>
                <p style={{ fontSize: "0.875rem", fontWeight: "bold" }}>
                  {activeEmiPlan
                    ? products
                        .sort((a, b) => a.tenure - b.tenure)
                        .find((product: any) => product.productId === activeEmiPlan)
                        ?.tenure
                    : "0"} {" "}
                  Months
                </p>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  flex: 1,
                }}
              >
                <img
                  src={biginterest}
                  style={{ width: "40px",height:'40px',marginBottom: "0.5rem" }}
                />
                <p style={{ color: "#737373", fontSize: "0.875rem" }}>
                  Starts On
                </p>
                <p
                  style={{
                    fontSize: "0.875rem",
                    fontWeight: "bold",
                    textDecoration: "underline",
                    color: "#d23028",
                    cursor: "pointer",
                  }}
                  // onClick={() =>
                  //   document.getElementById("emiDateInput")?.focus()
                  // }
                >
                  {getNextFifthDate()}
                  {/* {selectedDate ? formatDate(selectedDate) : "Select Date"} */}
                </p>
              </div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              flexDirection: "column",
            }}
          >
            <p
              style={{
                textAlign: "left",
                fontSize: "1.2rem",
                fontWeight: "bold",
                marginTop:'1rem'
              }}
            >
              Choose EMI plan
            </p>
            <div
              
            >
              {products
                .sort((a, b) => a.tenure - b.tenure)
                .map((product: any) => (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding:'8px 10px',
                      border:
                        activeEmiPlan === product.productId
                          ? "1px solid #D32028"
                          : "1px solid #F9D8D6",
                      borderRadius: "12px",
                      marginBottom: "1rem",
                      background: "#FFF8F4",
                      boxShadow: "0px 3px 3px rgba(211, 32, 40, 0.1)",
                      cursor:'pointer'
                    }}
                    key={product.productId}
                    onClick={() => {
                      setActiveEmiPlan(product.productId);
                      if (product?.emi !== undefined && product?.emi !== null) {
                        setEmiAmount(String(product.emi));
                      } else {
                        setEmiAmount((courseFees / Number(product.tenure)).toFixed(2));
                      }
                    }}
                  >
                    <Radio color="error" checked={product.productId===activeEmiPlan} />
                    <img src={emi} style={{width:'40px'}}/>
                    <p
                      style={{
                        textAlign: "left",
                        fontSize: "1rem",
                        fontWeight: "bold",
                      }}
                    >
                      {product?.emi !== undefined && product?.emi !== null
                        ? newFormatToIndianRupees(Number(product.emi))
                        : newFormatToIndianRupees(
                            Number(
                              Number(courseFees / Number(product.tenure)).toFixed(2)
                            )
                          )}
                    </p>
                    <p
                      style={{
                        textAlign: "center",
                        fontSize: "1rem",
                        // fontWeight: "bold",
                      }}
                    >
                      {product.tenure} Months
                    </p>
                    {/* {activeEmiPlan === product.productId ? <img src={selected}/>:null} */}
                  </div>
                ))}
            </div>
          </div>
          <br />
          <div style={{marginTop:'0.5rem', width:'40%', margin:'0 auto'
          }}> <Button
            text={loading?"Please Wait..":"Continue"}
            onPress={handleButtonClick}
            imageRight={ArrowRight}
            disabled={!activeEmiPlan && !emiAmount && loading }
            fullWidth
          /></div>
         
        </div>
       
        {/* <BottomNavigationBar active="Home"/> */}
      </div>
      <Footer/>
    </div>
  );
}

export default ViewOffer;
